import { useTranslation, Trans } from 'next-i18next';
import { Button } from '@forma/forma-ui-kit';
import Link from '@/components/Link';
import { ThemeContext } from '@forma/forma-ui-kit';
import styles from './seo-main-banner.module.css';
import Steps from '../parts/Steps';
import { useContext } from 'react';

const SeoMainBanner = ({ title, subtitle, steps }) => {
  const { t } = useTranslation();

  const { viewport } = useContext(ThemeContext);
  const isPhone = viewport === 'phone';
  return (
    <div className={styles.root}>
      {!isPhone && <div className={styles.bg} />}
      <Steps steps={steps}/>

      <h1 className={styles.title}>{title}</h1>
      <div className={styles.subtitle}>{subtitle}</div>
      <Button
        as={Link}
        className={styles.button}
        viewStyle="primary"
        href="#search"
      >
        {t('make_a_document_now')}
      </Button>
    </div>
  );
};

export default SeoMainBanner;
